import type { ThemeToggleContent } from "../types";

export const themeToggle: ThemeToggleContent = {
  toLight: "Skift til lyst tema",
  toDark: "Skift til mørkt tema",
};
